import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { EmailList, approveEmail, getEmail, resendEmail } from "@/api/data";
import { getGameServerMap, getGameGoodsMap, getUserInfoMap } from "@/utils/dictionary";
import infoList from "../../mixins/infoList";
import showEmailMsg from "./components/showEmailMsg.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  components: {
    showEmailMsg: showEmailMsg,
    DataOptions: DataOptions
  },
  name: "sendMailApproval",
  mixins: [infoList],
  data: function data() {
    return {
      //获取所有角色列表（申请人与审批人）
      UserInfoList: "",
      goodList: [],
      serverList: [],
      showMore: [],
      isFirstEnter: false,
      //是否是第一次进入页面
      listApi: EmailList,
      email_state: 1,
      approveID: "",
      approveBatch: false,
      emailID: "",
      multipleSelection: [],
      options: [{
        id: 0,
        label: "全部"
      }, {
        id: 1,
        label: "待审核"
      }, {
        id: 2,
        label: "审核驳回"
      }, {
        id: 3,
        label: "审核通过"
      }, {
        id: 4,
        label: "发送成功"
      }, {
        id: 5,
        label: "发送失败"
      }],
      emailStatus: {
        1: "待审核",
        2: "审核驳回",
        3: "审核通过",
        4: "发送成功",
        5: "发送失败"
      },
      classStatus: {
        1: "notApproved",
        2: "FailApproved",
        3: "Approved",
        4: "sendSuccess",
        5: "FailSend"
      },
      //填写审批原因弹出框
      centerDialogVisible: false,
      if_centerDialogVisible: false,
      isRadioType: 1,
      //查看邮件详细信息的弹出框
      dialogFormVisible: false,
      if_dialogFormVisible: false,
      //弹出框文本域
      // checkReacon: "",
      textarea1: "",
      //审核是否能通过
      radio: "0",
      nowEmailState: 0,
      //判断是修改1还是查看2
      auditType: 0,
      //点击查看邮件类型，1个人，2单服
      openEmailType: 0,
      //传给查看的每一行数据
      formData: {},
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      searchInfo: {
        email_state: ""
      },
      showReason: "",
      isShowBatch: false
    };
  },
  created: function created() {
    this.init();
  },
  // beforeRouteEnter(to, from, next) {
  //     // 利用路由元信息中的 meta 字段设置变量，方便在各个位置获取。这就是为什么在 meta 中定义 isNeedRefresh。
  //     // 当从详情页返回时，将 isNeedRefresh 设为 false，表示不刷新数据
  //     console.log("to", to);
  //     console.log("from", from);
  //     console.log("next", next);
  //     if (from.name === "MsgDetail") {
  //         to.meta.isNeedRefresh = false;
  //     }
  //     next();
  // },
  // mounted() {
  //     // 只有第一次进入或者刷新页面后才会执行此钩子函数,使用keep-alive后（2+次）进入不会再执行此钩子函数
  //     // isFirstEnter 用来标记是否第一次进入该页面，以防止用户在详情页手动刷新页面，回到该页面后不再请求数据
  //     this.isFirstEnter = true;
  // },
  // activated() {
  //     if (this.$route.meta.isNeedRefresh || this.isFirstEnter) {
  //         // 如果 isNeedRefresh 是 true，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
  //         this.queryListData();
  //     }
  //     // 恢复成默认的 false，避免 isFirstEnter 一直是 true，导致重复获取数据
  //     this.isFirstEnter = false;
  //     // 恢复成默认的 true，避免 isNeedRefresh 一直是 false，导致下次无法获取数据
  //     this.$route.meta.isNeedRefresh = true;
  // },
  methods: {
    showItemMore: function showItemMore(id) {
      this.showMore[id] = 1;
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, server;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserInfoMap();
            case 2:
              res = _context.sent;
              _this.UserInfoList = res;
              _context.next = 6;
              return getGameGoodsMap();
            case 6:
              _this.goodList = _context.sent;
              _context.next = 9;
              return getGameServerMap();
            case 9:
              server = _context.sent;
              _this.serverList = server;
              _this.queryEvent();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.formTime[0];
              _this2.searchInfo.edate = _this2.formTime[1];
              _this2.searchInfo.email_state = _this2.email_state;
              _context2.next = 5;
              return _this2.getTableData();
            case 5:
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
              if (_this2.email_state == 1) {
                _this2.isShowBatch = true;
              } else {
                _this2.isShowBatch = false;
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //新加的多选
    handleSelectionChange: function handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    //新加的审批
    approvalBtn: function approvalBtn() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择需要审批项",
          type: "warning"
        });
        return;
      }
      this.approveArr = this.multipleSelection.map(function (item) {
        return item.email_id;
      });
      this.radio = "0";
      this.nowEmailState = 1;
      this.auditType = 1;
      this.isRadioType = 2;
      this.if_centerDialogVisible = true;
      this.centerDialogVisible = true;
    },
    //查看邮件信息
    checkEmail: function checkEmail(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getEmail({
                email_id: row.email_id
              });
            case 2:
              res = _context3.sent;
              //判断是个人邮件还是单服邮件，查看显示的不一样
              if (row.email_type === 1) {
                _this3.openEmailType = 1;
              } else {
                _this3.openEmailType = 2;
              }
              _this3.formData = res.data.data;
              _this3.if_dialogFormVisible = true;
              _this3.dialogFormVisible = true;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //审批
    handleEdit: function handleEdit(row) {
      this.radio = "0";
      this.nowEmailState = row.email_state;
      this.showReason = row.reason;
      this.emailID = row.email_id;
      this.auditType = 1;
      this.isRadioType = 1;
      this.approveID = row.approve_id;
      this.if_centerDialogVisible = true;
      this.centerDialogVisible = true;
    },
    // 1:待审核，2:审核失败，3:审核通过,4:发送成功,5：发送失败
    handleCheckReason: function handleCheckReason(row) {
      this.auditType = 2;
      this.nowEmailState = row.email_state;
      this.showReason = row.reason;
      if (row.email_state === 1) {
        this.radio = "0";
      } else if (row.email_state === 2) {
        this.radio = "2";
      } else {
        this.radio = "1";
      }
      this.if_centerDialogVisible = true;
      this.centerDialogVisible = true;
    },
    //重新发送
    resendBtn: function resendBtn(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return resendEmail({
                email_id: row.email_id
              });
            case 2:
              res = _context4.sent;
              if (res.code == 0) {
                _this4.$message({
                  message: "恭喜你，邮件再次发送成功",
                  type: "success"
                });
                _this4.queryEvent();
                _this4.if_centerDialogVisible = false;
                _this4.centerDialogVisible = false;
              } else {
                _this4.$message({
                  message: "出错啦,联系开发人员",
                  type: "error"
                });
                _this4.if_centerDialogVisible = false;
                _this4.centerDialogVisible = false;
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    keepBtn: function keepBtn(e) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var arr, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              arr = [];
              if (e == 1) {
                arr.push(_this5.emailID);
              } else {
                arr = _this5.approveArr;
              }
              _context5.next = 4;
              return approveEmail({
                approve_id: _this5.approveID,
                ids: arr,
                is_approve: _this5.radio == 1 ? true : false,
                reason: _this5.showReason
              });
            case 4:
              res = _context5.sent;
              if (res.code === 0) {
                _this5.$message({
                  message: "恭喜你，邮件审核成功",
                  type: "success"
                });
                _this5.if_centerDialogVisible = false;
                _this5.centerDialogVisible = false;
              } else {
                _this5.$message({
                  message: "出错啦",
                  type: "error"
                });
                _this5.if_centerDialogVisible = false;
                _this5.centerDialogVisible = false;
              }
              _this5.queryEvent();
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "邮件审批",
        message: "(1)有审批菜单权限的人员，可以审批已经发出邮件申请的邮件。" + "(2)邮件审批状态分位：审核通过，审核驳回。" + "(3)审批需要填写审批原因，记录审批人员Id、时间" + "（4）如果通过审批，调用研发提供的邮件发送接口，发送邮件" + "（5）记录调用研发接口的返回状态和原因（包括成功和失败)" + "（6）审批通过后，邮件不支持任何修改" + "(7)审批驳回后，邮件可在邮件申请里修改邮件内容，和增删邮件附件，重新提交邮件申请",
        duration: 0
      });
    }
  }
};